import React, { Component } from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';

import {createVideo, updateActiveChannelListIndex, showModalFlag} from '../../actions';
import ChannelItem from './ChannelItem';
import {Config, Api} from '../../util';
import {Video} from '../../components/modal';


class Channel extends Component {
  constructor(props){
    super(props);
    this.state = {
      index: 0,
      showModal: false,
      modalInfo: {},
    };
    
    this.prevChannel = this.prevChannel.bind(this);
    this.nextChannel = this.nextChannel.bind(this);

    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleOnContextMenuClick = this.handleOnContextMenuClick.bind(this);

  }

  
  async getLivePlayInfo(chname){
    try{
      const liveInfo = (await Api.SearchLiveCh()).files.file;
      return liveInfo.filter(info => info.chName === chname)[0]
    }catch(e){
      console.log(e);
    }
  }

  async handleOnContextMenuClick(channelInfo) {
    const {chname, data} = channelInfo;
    const liveInfo = await this.getLivePlayInfo(chname);

    liveInfo.active = liveInfo.active === 'Y';
    liveInfo.live = true;

    if(data === 'Popup'){ 
      // Popup
      await this.setState({
        showModal: true,
        modalInfo: liveInfo
      });
      await this.props.showModalFlag(this.state.showModal);
      
    } else {
      // Preview  
      const videoNum = data.toLowerCase();
      const videoObj = {};
      videoObj[videoNum] = Object.assign({}, channelInfo, liveInfo);
      this.props.createVideo(videoObj);
    }

  }

  async handleModalClose(){
    await this.setState({showModal: false});
    await this.props.showModalFlag(this.state.showModal);
  }

  

  prevChannel(){
    const {
      activeChannelListIndex,
      updateActiveChannelListIndex
    } = this.props;
    if(activeChannelListIndex > 0){
      updateActiveChannelListIndex(activeChannelListIndex - 1);
    }
  }
  nextChannel(){
    const {
      channelList,
      activeChannelListIndex,
      updateActiveChannelListIndex
    } = this.props;
    const chLimit =  channelList.length / Config.channelCnt;
    if(chLimit-1 > activeChannelListIndex){
      updateActiveChannelListIndex(activeChannelListIndex + 1);
    }
  }

  render() {
    const {
      channelList,
      activeChannelListIndex
    } = this.props;
    const {
      showModal,
      modalInfo
    } = this.state;

    const chLimit =  channelList.length / Config.channelCnt;
    const prevIconClasses = 'icon channel_left ' + (activeChannelListIndex === 0 ? ' disabled' : '');
    const nextIconClasses = 'icon channel_right' + (activeChannelListIndex >= (chLimit-1) ? ' disabled' : '');

    return (
      <div className='channel list'>
        <span className={prevIconClasses} onClick={this.prevChannel}></span>
        {channelList.map((channelInfo, index) => {
          const channelIndex = parseInt(index / Config.channelCnt, 10);
          return (
            <ChannelItem 
              key={channelInfo.chid} 
              channelInfo={channelInfo} 
              channelIndex={channelIndex}
              onContextMenuClick={this.handleOnContextMenuClick}/>
          )
        })}
        {showModal ? <Video 
          handleModalClose = {this.handleModalClose}
          modalInfo = {modalInfo}
          key='video' 
        /> : null}
        <span className={nextIconClasses} onClick={this.nextChannel}></span>
      </div>
    );
  }
}

const mapDispatcherToProps = dispatch => {
  return {
    createVideo: (videoItem) => dispatch(createVideo(videoItem)),
    showModalFlag: (modalFlag) => dispatch(showModalFlag(modalFlag)),
    updateActiveChannelListIndex: (chIndex) => dispatch(updateActiveChannelListIndex(chIndex))
  }
};
const mapStateToProps = (state) =>{
  return {
    activeChannelListIndex: state.activeChannelListIndex,
    selectedDate: state.selectedDate,
    channelList: state.channelList
  }
};

Channel = connect(mapStateToProps, mapDispatcherToProps)(Channel);

export default Channel;


// WEBPACK FOOTER //
// ./src/components/channel/index.js